module.exports = "https://static.wmbcdn.com/uniweb/images/c5d4d83e331ecf10e2cba78d703be1d1.svg";